/*global Materialize*/
/*eslint no-undef: ["error", { "typeof": true }] */

import React, { Component } from "react";
import Button from "../../../components/Button";
import PropTypes from "prop-types";

import ModalConfirm from "../../../components/Modal/ModalConfirm";
import ModalTerminate from "../../../components/Modal/ModalTerminate";

/** Components */
import TextInput from "../../../components/TextInput";
import Select from "../../../components/Select";
import EnrollmentCard from "../../../components/EnrollmentCard";

/** Modules */
import { fetch } from "@fyresite/fetch";
import moment from "moment";
import { connect } from "react-redux";

class EnrollMember extends Component {
    constructor(props, context) {
        super(props, context);

        let today = moment();
        this.defaultState = {
            /** Eligibility Form VAriables */
            actionCode: "A",
            actionCode_valid: true,
            accumulationLimit_valid: true,
            accumulationLimit_enabled: false,

            form: {},

            /** Constant Variables */
            carrierCode: "AS",
            fileFormatMinorVersion: "02",
            fileFormatVersion: "06",
            recordCode: "$M",
            relationshipCode: "P",
            coverageCode: "I",
            awardIdentifier: "",
            awardIdentifier_valid: true,
        };

        this.state = {
            programs: [],
            member: {},
            program: "0",
            programModel: "",
            accumulationLimit: 20000,
            coverageEffectiveDate: today.utc().format("YYYY-MM-DD"),
            coverageEffectiveDate_valid: true,
            ...this.defaultState,
        };

        this.handleInputKeyPress = this.handleInputKeyPress.bind(this);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleInputKeyPress);
    }

    componentWillMount() {
        this.getPrograms();
        this.getMember();
        document.addEventListener("keydown", this.handleInputKeyPress);
    }

    handleInputKeyPress(e) {
        if (e.key.toLowerCase() === "enter") {
            if (this.state.program !== "0") {
                this.handleSubmit(e);
            }
        }
    }

    getPrograms() {
        fetch(`/api/v1/programs/get-all`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        })
            .then((res) => {
                return res.json();
            })
            .then((json) => {
                if (json.code === 200) {
                    let programs = json.result.programs;
                    this.setState({
                        programs: programs,
                    });
                } else {
                    Materialize.toast(
                        `Error occurred, ${json.message}`,
                        4000,
                        "red"
                    );
                }
            })
            .catch((err) => {
                Materialize.toast(`Fetch error, ${err}`, 4000, "red");
            });
    }

    getMember() {
        fetch(`/api/v1/member/read/${this.props.match.params.id}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        })
            .then((res) => {
                return res.json();
            })
            .then((json) => {
                if (json.code === 200) {
                    let member = json.result.member;
                    this.setState({
                        member: member,
                    });
                } else {
                    Materialize.toast(
                        `Error occurred, ${json.message}`,
                        4000,
                        "red"
                    );
                }
            })
            .catch((err) => {
                Materialize.toast(`Fetch error, ${err}`, 4000, "red");
            });
    }

    getEligibilityFile() {
        fetch(
            `/api/v1/eligibility/find?MemberId=${this.state.member.id}&ProgramId=${this.state.program}`,
            {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            }
        )
            .then((res) => {
                return res.json();
            })
            .then((json) => {
                if (json.code === 200) {
                    let form = json.result.form;
                    this.setState({
                        form,
                        ...form,
                    });
                } else {
                    this.setState({
                        form: {},
                        ...this.defaultState,
                    });
                }
            })
            .catch((err) => {
                Materialize.toast(`Fetch error, ${err}`, 4000, "red");
            });
    }

    handleChange(field, e) {
        let valid = false;
        let value = e.target.value;

        switch (field) {
            case "coverageEffectiveDate":
                if (e.target.value.length > 0) {
                    let selectedDate = moment(e.target.value);
                    let terminationDate = moment(
                        this.state.programModel.coverageTerminationDate
                    );

                    if (selectedDate < terminationDate) {
                        let minDate = moment(
                            this.state.programModel.minEffectiveDate
                        );
                        valid = selectedDate >= minDate;
                    }
                }
                break;
            case "awardIdentifier":
                valid = value.length <= 10;
                break;
            default:
                if (e.target.value.length > 0) {
                    valid = true;
                }
                break;
        }

        if (field === "program") {
            let program;

            this.state.programs.forEach((loopedProgram) => {
                if (
                    parseInt(e.target.value, 10) ===
                    parseInt(loopedProgram.id, 10)
                ) {
                    program = loopedProgram;
                }
            });

            let limit = 0;

            let coverageEffectiveDate = moment(
                this.state.coverageEffectiveDate
            );
            let coverageEffectiveDate_valid = true;
            if (program) {
                limit = program.defaultAccumulation;

                let coverageTerminationDate = moment(
                    program.coverageTerminationDate
                );
                let minEffectiveDate = moment(program.minEffectiveDate);
                let curDate = moment();

                if (
                    curDate.isAfter(minEffectiveDate) &&
                    curDate.isBefore(coverageTerminationDate)
                ) {
                    coverageEffectiveDate = curDate;
                } else {
                    coverageEffectiveDate = minEffectiveDate;
                }

                coverageEffectiveDate_valid = coverageEffectiveDate.isAfter(
                    moment(program.coverageTerminationDate)
                )
                    ? false
                    : true;
            }

            this.setState(
                {
                    [field]: value,
                    [`${field}_valid`]: valid,
                    accumulationLimit: limit,
                    programModel: program,
                    coverageEffectiveDate,
                    coverageEffectiveDate_valid,
                },
                () => {
                    this.getEligibilityFile();
                }
            );
        } else {
            console.log(value, valid);
            this.setState({
                [field]: value,
                [`${field}_valid`]: valid,
            });
        }
    }

    handleTerminate(e) {
        this.context.showModal(
            true,
            <ModalTerminate
                minDate={moment(this.state.coverageEffectiveDate)
                    .utc()
                    .format("YYYY-MM-DD")}
                onSubmit={(async (date) => {
                    if (
                        moment(this.state.coverageEffectiveDate) > moment(date)
                    ) {
                        return Materialize.toast(
                            `Termination date can not precede effective date`,
                            4000,
                            "red"
                        );
                    }

                    const coverageTerminationDate = moment(date)
                        .utc()
                        .format("YYYY-MM-DD");
                    try {
                        const json = await fetch(
                            `/api/v1/eligibility/update/${this.state.form.id}`,
                            {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({
                                    actionCode: "T",
                                    coverageTerminationDate,
                                }),
                            }
                        ).then((res) => res.json());

                        if (json.code === 200) {
                            this.setState({
                                form: json.result.form,
                                actionCode: "T",
                            });
                            Materialize.toast(
                                `Eligibility has been set to terminate on ${coverageTerminationDate}`,
                                4000,
                                "green"
                            );
                            this.context.showModal(false);
                        } else {
                            Materialize.toast(
                                `Error occurred, ${json.message}`,
                                4000,
                                "red"
                            );
                        }
                    } catch (err) {
                        Materialize.toast(`Fetch error, ${err}`, 4000, "red");
                    }
                }).bind(this)}
            />
        );

        return;
    }

    handleUpdate(e) {
        if (!this.state.coverageEffectiveDate_valid) {
            Materialize.toast(
                `Coverage cannot begin before ${moment(
                    this.state.programModel.minEffectiveDate
                )
                    .utc()
                    .format("MM/DD/YYYY")} or after ${moment(
                    this.state.programModel.coverageTerminationDate
                )
                    .utc()
                    .format("MM/DD/YYYY")}`,
                4000,
                "red"
            );
            return;
        }
        if (
            !this.state.awardIdentifier_valid &&
            this.state.awardIdentifier.length > 10
        ) {
            Materialize.toast(
                "Award identifier is invalid. It must be 10 characters or less",
                4000,
                "red"
            );
            return;
        }

        fetch(`/api/v1/eligibility/update/${this.state.form.id}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                awardIdentifier: this.state.awardIdentifier,
                coverageEffectiveDate: this.state.coverageEffectiveDate,
            }),
        })
            .then((res) => {
                return res.json();
            })
            .then((json) => {
                if (json.code === 200) {
                    Materialize.toast(
                        `Eligibility form was updated`,
                        4000,
                        "green"
                    );
                } else {
                    Materialize.toast(
                        `Error occurred, ${json.message}`,
                        4000,
                        "red"
                    );
                }
            })
            .catch((err) => {
                Materialize.toast(`Fetch error, ${err}`, 4000, "red");
            });
    }

    handleResendRecord = async (e) => {
        try {
            const res = await fetch(
                `/api/v1/eligibility/update/${this.state.form.id}`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                }
            );
            const json = await res.json();
            if (json.code === 200)
                Materialize.toast("Record has been resent", 4000, "green");
            else throw json.message;
        } catch (error) {
            Materialize.toast(`Error Occurred, ${error}`, 4000, "red");
        }
    };

    handleSubmit(e) {
        let confirm = window.confirm(
            "Are you sure you want to submit this form?"
        );
        if (!confirm) {
            return false;
        }

        let options = JSON.parse(JSON.stringify(this.state));

        for (var x = 0; x < Object.keys(this.state).length; x++) {
            let key = Object.keys(this.state)[x];
            if (key.indexOf("_valid") !== -1) {
                if (!this.state[key]) {
                    switch (key) {
                        case "coverageEffectiveDate_valid":
                            Materialize.toast(
                                `Coverage cannot begin before ${moment(
                                    this.state.programModel.minEffectiveDate
                                )
                                    .utc()
                                    .format("MM/DD/YYYY")} or after ${moment(
                                    this.state.programModel
                                        .coverageTerminationDate
                                )
                                    .utc()
                                    .format("MM/DD/YYYY")}`,
                                4000,
                                "red"
                            );
                            return;
                        default:
                            Materialize.toast(
                                `Please fill out ${key.replace(
                                    /_valid/gi,
                                    ""
                                )} field`,
                                4000,
                                "red"
                            );
                            return;
                    }
                }
                /** Remove unnecessary data from options */
                delete options[key];
            }
        }

        /** Remove unnecessary data from options */
        delete options.member;
        delete options.programs;
        delete options.programModel;
        /** Set Associative ID's */
        options.MemberId = this.state.member.id;
        options.ProgramId = this.state.program;
        options.coverageTerminationDate =
            this.state.programModel.coverageTerminationDate;
        /** Set necessary Member fields */
        options.firstName = this.state.member.firstName;
        options.lastName = this.state.member.lastName;
        options.gender = "X";
        options.dateOfBirth = this.state.member.dateOfBirth;
        options.awardIdentifier = this.state.awardIdentifier;

        fetch(`/api/v1/eligibility/create`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(options),
        })
            .then((res) => {
                return res.json();
            })
            .then((json) => {
                if (json.code === 200) {
                    this.props.history.push(
                        `/dashboard/enroll-confirmation/${json.result.form.id}`
                    );
                    Materialize.toast(
                        `Eligibility form was sent successfully`,
                        4000,
                        "green"
                    );
                } else {
                    Materialize.toast(
                        `Error occurred, ${json.message}`,
                        4000,
                        "red"
                    );
                }
            })
            .catch((err) => {
                Materialize.toast(`Fetch error, ${err}`, 4000, "red");
            });
    }

    handleAccumEdit(e) {
        if (this.state.accumulationLimit_enabled) {
            this.setState({
                accumulationLimit_enabled: false,
            });
        } else {
            this.context.showModal(
                true,
                <ModalConfirm
                    header={"Are you sure?"}
                    message={
                        "Caution: This will change the member's award/benefit amount"
                    }
                    button={{
                        onClick: (e) => {
                            this.setState(
                                { accumulationLimit_enabled: true },
                                () => {
                                    this.context.showModal(false);
                                }
                            );
                        },
                        text: "Yes",
                    }}
                    cancel={{ text: "No" }}
                />
            );
        }
    }

    renderAccumulationCard() {
        let html = [];
        this.state.programs.forEach((program) => {
            if (parseInt(this.state.program, 10) === parseInt(program.id, 10)) {
                if (program.defaultAccumulation !== 0) {
                    //Existing Form
                    if (Object.keys(this.state.form).length > 0) {
                        html.push(
                            <div
                                key="accumLimit"
                                className="form-card card z-depth-5"
                                ref="form-card"
                            >
                                <div className="card-content">
                                    <span className="card-title">
                                        Award/Benefit Conversion
                                    </span>
                                    <span className="card-subtitle">
                                        For new member enrollements only
                                    </span>
                                    <form
                                        onSubmit={this.handleSubmit.bind(this)}
                                        className="left-align"
                                        noValidate
                                    >
                                        <div className="row">
                                            <TextInput
                                                className="col s12 m12"
                                                id={"accumulationLimit"}
                                                ref={"accumulationLimit"}
                                                label={"Accumulation Limit $"}
                                                disabled={true}
                                                type="number"
                                                valid={
                                                    this.state
                                                        .accumulationLimit_valid
                                                }
                                                value={parseFloat(
                                                    this.state
                                                        .accumulationLimit,
                                                    10
                                                ).toFixed(2)}
                                                onChange={this.handleChange.bind(
                                                    this,
                                                    "accumulationLimit"
                                                )}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        );
                    } else {
                        //New Enrollment Form
                        html.push(
                            <div
                                key="accumLimit"
                                className="form-card card z-depth-5"
                                ref="form-card"
                            >
                                <div className="card-content">
                                    <span className="card-title">
                                        Award/Benefit Conversion
                                    </span>
                                    <span className="card-subtitle">
                                        For new member enrollements only
                                    </span>
                                    <form
                                        onSubmit={this.handleSubmit.bind(this)}
                                        className="left-align"
                                        noValidate
                                    >
                                        <div className="row">
                                            <TextInput
                                                className="col s10 m10"
                                                id={"accumulationLimit"}
                                                ref={"accumulationLimit"}
                                                type="number"
                                                label={"Accumulation Limit $"}
                                                disabled={
                                                    !this.state
                                                        .accumulationLimit_enabled
                                                }
                                                valid={
                                                    this.state
                                                        .accumulationLimit_valid
                                                }
                                                value={parseFloat(
                                                    this.state
                                                        .accumulationLimit,
                                                    10
                                                ).toFixed(2)}
                                                onChange={this.handleChange.bind(
                                                    this,
                                                    "accumulationLimit"
                                                )}
                                            />
                                            <Button
                                                className="accum-button col s2 m2"
                                                color={
                                                    this.state
                                                        .accumulationLimit_enabled
                                                        ? "red"
                                                        : "green"
                                                }
                                                flat={false}
                                                onClick={this.handleAccumEdit.bind(
                                                    this
                                                )}
                                                z-depth={1}
                                            >
                                                {this.state
                                                    .accumulationLimit_enabled
                                                    ? "Disable"
                                                    : "Edit"}
                                            </Button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        );
                    }
                }
            }
        });

        return html;
    }

    render() {
        let programs = false;

        if (this.state.programs.length > 0) {
            programs = {};
            programs["0"] = "Select Program";
            this.state.programs.forEach((program) => {
                programs[program.id] = program.program;
            });
        }

        return (
            <div className="enroll-member">
                <div className="enroll-member-inner">
                    <div className="card-container card-wrapper">
                        <div
                            className="form-card card z-depth-5"
                            ref="form-card"
                        >
                            <div className="card-content">
                                <span className="card-title">
                                    Program Enrollment
                                </span>
                                <h7>
                                    {" "}
                                    Members require a program before being
                                    enrolled.
                                </h7>
                                <form
                                    onSubmit={this.handleSubmit.bind(this)}
                                    className="left-align"
                                    noValidate
                                >
                                    {this.state.programs.length > 0 ? (
                                        <Select
                                            id={"program"}
                                            ref={"program"}
                                            options={programs}
                                            valid={this.state.program_valid}
                                            value={this.state.program}
                                            onChange={this.handleChange.bind(
                                                this,
                                                "program"
                                            )}
                                        />
                                    ) : (
                                        ""
                                    )}
                                </form>
                            </div>
                        </div>
                        {this.renderAccumulationCard()}
                        {this.state.program !== "0" ? (
                            <EnrollmentCard
                                {...this.props}
                                handleChange={this.handleChange.bind(this)}
                                member={this.state.member}
                                user={this.props.user}
                                awardIdentifier={this.state.awardIdentifier}
                                awardIdentifier_valid={
                                    this.state.awardIdentifier_valid
                                }
                                recordCode={this.state.recordCode}
                                fileFormatMinorVersion={
                                    this.state.fileFormatMinorVersion
                                }
                                fileFormatVersion={this.state.fileFormatVersion}
                                carrierCode={this.state.carrierCode}
                                coverageCode={this.state.coverageCode}
                                relationshipCode={this.state.relationshipCode}
                                actionCode={this.state.actionCode}
                                actionCode_valid={this.state.actionCode_valid}
                                coverageEffectiveDate={moment(
                                    this.state.coverageEffectiveDate
                                )
                                    .utc()
                                    .format("YYYY-MM-DD")}
                                coverageEffectiveDate_valid={
                                    this.state.coverageEffectiveDate_valid
                                }
                                minEffectiveDate={
                                    this.state.programModel.minEffectiveDate
                                }
                                title={"Enrollment Form"}
                                form={this.state.form}
                                onSubmit={this.handleSubmit.bind(this)}
                                onUpdate={this.handleUpdate.bind(this)}
                                onResendRecord={this.handleResendRecord}
                                onTerminate={this.handleTerminate.bind(this)}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

EnrollMember.contextTypes = {
    showModal: PropTypes.func,
};
const mapStateToProps = (state) => ({
    user: state.user,
});

export default connect(mapStateToProps)(EnrollMember);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/EnrollMember/EnrollMember.js